module.exports = __webpack_public_path__ + "img/slidebar-bg.c9d141f2.png";